/** Lowercase, strip diacritics, drop separators — `JA-108K` ≡ `ja108k`, `sběrnice` ≡ `sbernice`. */
export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

export function normalizeCode(value: string): string {
  return normalizeSearchText(value);
}

/**
 * Short searchable form of a commercial code when it contains separators
 * (`JA-103K` → `ja103k`). Returns null when there is nothing to strip.
 */
export function shortProductCode(code: string): string | null {
  if (!code || !/[-_\s]/.test(code)) {
    return null;
  }
  const short = normalizeCode(code);

  return short && short !== code.toLowerCase() ? short : null;
}
